import { AssetType as u } from "../../../temp-lib/constants/url.js";
import m from "../../../temp-lib/hooks/generic/useApeironPathMaker.js";
import f from "../../../temp-lib/hooks/json/useFetchJson.js";
import { singleOperation as h } from "../../../temp-lib/util/operation/singleOperation.js";
import * as t from "ramda";
import { useCallback as n } from "react";
let o = null;
const j = "fetch_constellation_data", _ = () => {
  const { makePath: c } = m(), l = n(() => o, []), { fetchJson: s } = f({
    url: c(u.Json, "star/constellation.json")
  }), a = n(
    () => async () => s(),
    [s]
  ), p = n(async () => {
    t.isNil(o) && (o = await h(j, a()));
  }, [a]), i = n((e) => {
    if (!t.is(Array, e) && !t.is(Object, e)) {
      if (t.is(String, e) && t.startsWith("api::", e)) {
        const r = t.replace("api::", "", e);
        return t.propOr("", r, o);
      }
      return e;
    }
    return t.map((r) => i(r), e);
  }, []);
  return {
    data: l,
    fetchData: p,
    injectData: i
  };
};
export {
  _ as default
};
//# sourceMappingURL=useInjectConstellation.js.map
